import styled, {css} from "styled-components";
import {StickyNavigationMenuItemIconDefaultBox} from "./sticky-navigation-menu-item-icon.default.box";

const iconNormalStatePosY: string = "-234px";
const iconActiveStatePosY: string = "-296px";

export const StickyNavigationMenuItemIconCasino777Box = styled(StickyNavigationMenuItemIconDefaultBox)`

  ${props => {

    if (props.icon === "home") {

      if (props.isActive) return css`
        background-position: -424px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -424px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "slots") {

      if (props.isActive) return css`
        background-position: -568px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -568px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "casino-games") {

      if (props.isActive) return css`
        background-position: -646px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -646px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "live-casino") {

      if (props.isActive) return css`
        background-position: -495px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -495px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "jackpots") {

      if (props.isActive) return css`
        background-position: -734px ${iconActiveStatePosY};
      `;

      return css`
        background-position: -734px ${iconNormalStatePosY};
      `;
    }

    if (props.icon === "deposit") {
      return css`
        background-position: -732px ${iconNormalStatePosY};
      `;
    }

  }}
`;
